import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Package, CaretDown, ClipboardText, Factory, Tag, ChartBar, DownloadSimple, UploadSimple, CurrencyEur } from "@phosphor-icons/react";
import { useCtnRights } from "./shared";

const CTN_LINKS = [
  { path: "bestellingen", title: "Bestellingen", icon: ClipboardText, color: "#2563EB" },
  { path: "concepten", title: "Lokale concepten", icon: ClipboardText, color: "#B45309" },
  { path: "leveranciers", title: "Leveranciers", icon: Factory, color: "#C2410C" },
  { path: "categorieen", title: "Categorieën", icon: Tag, color: "#BE185D" },
  { path: "koersen", title: "Koersen", icon: CurrencyEur, color: "#B45309", purchase: true },
  { path: "rapporten", title: "Rapporten", icon: ChartBar, color: "#15803D" },
  { path: "export", title: "Back-up / Export", icon: DownloadSimple, color: "#0E7490" },
  { path: "import", title: "Import", icon: UploadSimple, color: "#15803D", manage: true },
];

export const CtnNav = ({ onNavigate, mobileOpen }) => {
  const { purchase, manage } = useCtnRights();
  const location = useLocation();
  const active = location.pathname.startsWith("/ctn");
  const [open, setOpen] = useState(active);
  const group = useRef(null);
  useEffect(() => { if (mobileOpen && active) setOpen(true); }, [mobileOpen, active]);
  useEffect(() => {
    if (open && mobileOpen) {
      const frame = requestAnimationFrame(() => group.current?.scrollIntoView({ block: "nearest" }));
      return () => cancelAnimationFrame(frame);
    }
  }, [open, mobileOpen]);
  return <div ref={group} data-testid="nav-ctn-group">
    <button type="button" className={`sidebar-link w-full ${active ? "active" : ""}`} aria-expanded={open} onClick={() => setOpen(!open)} data-testid="nav-ctn-toggle"><Package size={20} weight="bold" color="#C2410C" className="shrink-0" data-testid="nav-icon-ctn" /><span className="flex-1 text-left">Bestelling CTN</span><CaretDown size={14} color="#C2410C" data-testid="nav-icon-ctn-chevron" className={`transition-transform ${open ? "rotate-180" : ""}`} /></button>
    {open && <div data-testid="nav-ctn-submenu" className="pl-5">{CTN_LINKS.filter((link) => (!link.purchase || purchase) && (!link.manage || manage)).map((link) => <NavLink key={link.path} to={`/ctn/${link.path}`} onClick={onNavigate} className={({ isActive }) => `sidebar-link text-xs ${isActive ? "active" : ""}`} data-testid={`nav-ctn-${link.path}`}><link.icon size={16} weight="bold" color={link.color} className="shrink-0" data-testid={`nav-icon-ctn-${link.path}`} />{link.title}</NavLink>)}</div>}
  </div>;
};